var __create = Object.create;
var __defProp = Object.defineProperty;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __assign = Object.assign;
var __markAsModule = (target) => __defProp(target, "__esModule", {value: true});
var __commonJS = (callback, module2) => () => {
  if (!module2) {
    module2 = {exports: {}};
    callback(module2.exports, module2);
  }
  return module2.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {get: all[name], enumerable: true});
};
var __exportStar = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, {get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable});
  }
  return target;
};
var __toModule = (module2) => {
  if (module2 && module2.__esModule)
    return module2;
  return __exportStar(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", {value: module2, enumerable: true})), module2);
};

// ../../common/temp/node_modules/.pnpm/p-cancelable@2.1.1/node_modules/p-cancelable/index.js
var require_p_cancelable = __commonJS((exports2, module2) => {
  "use strict";
  var CancelError = class extends Error {
    constructor(reason) {
      super(reason || "Promise was canceled");
      this.name = "CancelError";
    }
    get isCanceled() {
      return true;
    }
  };
  var PCancelable2 = class {
    static fn(userFn) {
      return (...arguments_) => {
        return new PCancelable2((resolve, reject, onCancel) => {
          arguments_.push(onCancel);
          userFn(...arguments_).then(resolve, reject);
        });
      };
    }
    constructor(executor) {
      this._cancelHandlers = [];
      this._isPending = true;
      this._isCanceled = false;
      this._rejectOnCancel = true;
      this._promise = new Promise((resolve, reject) => {
        this._reject = reject;
        const onResolve = (value) => {
          if (!this._isCanceled || !onCancel.shouldReject) {
            this._isPending = false;
            resolve(value);
          }
        };
        const onReject = (error) => {
          this._isPending = false;
          reject(error);
        };
        const onCancel = (handler) => {
          if (!this._isPending) {
            throw new Error("The `onCancel` handler was attached after the promise settled.");
          }
          this._cancelHandlers.push(handler);
        };
        Object.defineProperties(onCancel, {
          shouldReject: {
            get: () => this._rejectOnCancel,
            set: (boolean) => {
              this._rejectOnCancel = boolean;
            }
          }
        });
        return executor(onResolve, onReject, onCancel);
      });
    }
    then(onFulfilled, onRejected) {
      return this._promise.then(onFulfilled, onRejected);
    }
    catch(onRejected) {
      return this._promise.catch(onRejected);
    }
    finally(onFinally) {
      return this._promise.finally(onFinally);
    }
    cancel(reason) {
      if (!this._isPending || this._isCanceled) {
        return;
      }
      this._isCanceled = true;
      if (this._cancelHandlers.length > 0) {
        try {
          for (const handler of this._cancelHandlers) {
            handler();
          }
        } catch (error) {
          this._reject(error);
          return;
        }
      }
      if (this._rejectOnCancel) {
        this._reject(new CancelError(reason));
      }
    }
    get isCanceled() {
      return this._isCanceled;
    }
  };
  Object.setPrototypeOf(PCancelable2.prototype, Promise.prototype);
  module2.exports = PCancelable2;
  module2.exports.CancelError = CancelError;
});

// src/index.ts
__markAsModule(exports);
__export(exports, {
  waitDisappearElement: () => waitDisappearElement,
  waitElement: () => waitElement
});
var import_p_cancelable = __toModule(require_p_cancelable());

// src/options.ts
var defaultOptions = () => ({
  target: document,
  timeout: 0,
  observeConfigs: {
    childList: true,
    subtree: true,
    attributes: true
  }
});
var mergeOptions = (defaultOptions2, userPassingOptions) => {
  const observeConfigs = __assign(__assign({}, defaultOptions2.observeConfigs), userPassingOptions == null ? void 0 : userPassingOptions.observeConfigs);
  const options = __assign(__assign(__assign({}, defaultOptions2), userPassingOptions), {
    observeConfigs
  });
  return options;
};

// src/detectConditions.ts
var isAppeared = (element) => {
  return element !== null;
};
var isDisappeared = (element) => {
  return !isAppeared(element);
};

// src/index.ts
function createWaitElement(isMatchDetectCondition) {
  return function(selector, _options) {
    const options = _options ? mergeOptions(defaultOptions(), _options) : defaultOptions();
    const checkElement = (selector2) => {
      return options.target.querySelector(selector2);
    };
    return new import_p_cancelable.default((resolve, reject, onCancel) => {
      let _hasObserved = false;
      let _timeoutId;
      const observer = new MutationObserver((mutations) => {
        mutations.some(() => {
          const element2 = checkElement(selector);
          if (isMatchDetectCondition(element2)) {
            if (_timeoutId) {
              clearTimeout(_timeoutId);
            }
            observer.disconnect();
            _hasObserved = true;
            resolve(element2);
            return true;
          }
          return false;
        });
      });
      onCancel(() => {
        if (_timeoutId) {
          clearTimeout(_timeoutId);
        }
        observer.disconnect();
        _hasObserved = true;
      });
      const element = checkElement(selector);
      if (isMatchDetectCondition(element)) {
        _hasObserved = true;
        resolve(element);
        return;
      }
      observer.observe(options.target, options.observeConfigs);
      if (options.timeout > 0 && !_hasObserved) {
        _timeoutId = setTimeout(() => {
          if (!_hasObserved) {
            observer.disconnect();
            reject(new Error(`Element was not found: ${selector}`));
          }
        }, options.timeout);
      }
    });
  };
}
var waitElement = createWaitElement(isAppeared);
var waitDisappearElement = createWaitElement(isDisappeared);
